module.exports = __webpack_public_path__ + "img/google-icon.de71801d.svg";